import {Component} from "@angular/core";

@Component({
    selector: 'app-image-formatter-cell',
    template: `
        <table style="width:95%">
            <tr>
                <td>{{params.color(params)}}&nbsp;&nbsp;</td>

                <td *ngIf="params.value != '' && params.value != undefined"><img class="d-inline-block pull-right"
                                                                                 [src]=atob(params.value) width="30"
                                                                                 height="30" vertical-align="middle"/>
                </td>
            </tr>
        </table> `
})

export class ImageCustomerFormatterComponent {
    params: any;

    agInit(params: any) {
        this.params = params;
    }

    atob(logo: string) {
        if (logo) {
            return window.atob(logo);
        }

    }
}
